import closeIcon from './icon-close.png'

export default function CloseBtn({ onClick, className }: { onClick?: () => void; className?: string }) {
  return (
    <button
      onClick={() => onClick?.()}
      className={`w-4 h-4 rounded-full bg-transparent border-0 outline-none ${className ?? ''}`}>
      <img className="h-full w-full" src={closeIcon} alt="" />
    </button>
  )
}
